import { RefreshCw } from 'lucide-react';

import { Button } from '@/design-system/ui/Button';
import { dismissUpdate, updateNow, usePwa } from '@/pwa/installState';

/**
 * Versão nova do Live Gospel baixada pelo service worker: troca só quando a pessoa pede, para
 * não recarregar no meio de um cadastro.
 */
export default function UpdatePrompt() {
  const { updateReady } = usePwa();

  if (!updateReady) return null;

  return (
    <div
      role="status"
      className="fixed right-4 bottom-24 left-4 z-[90] flex flex-wrap items-center gap-3 rounded-card border border-line-card bg-white p-3.5 shadow-dialog md:bottom-6 md:left-auto md:w-96"
    >
      <span className="grid size-9 shrink-0 place-items-center rounded-control bg-primary-soft text-primary">
        <RefreshCw aria-hidden className="size-4.5 stroke-[1.8]" />
      </span>
      <p className="m-0 min-w-40 flex-1 text-small text-ink">
        <strong className="block">Nova versão do Live Gospel</strong>
        Atualize para usar as últimas melhorias.
      </p>
      <div className="flex gap-2">
        <Button size="sm" variant="ghost" onClick={dismissUpdate}>
          Depois
        </Button>
        <Button size="sm" onClick={() => void updateNow()}>
          Atualizar
        </Button>
      </div>
    </div>
  );
}
